import { GenericSlider, SliderConfig } from 'assets/js/slider.js';

class SliderBubble extends HTMLElement {
  constructor() {
    super();
    this.slider = null;
  }

  connectedCallback() {
    const config = new SliderConfig({
      listSelector: '.bubble-list',
      itemSelector: '.bubble-box',
      controlsSelector: '.navigation-controls',
      prevButtonSelector: '.prev',
      nextButtonSelector: '.next'
    });

    this.slider = new GenericSlider(this, config);
    this.slider.init();
  }

  disconnectedCallback() {
    this.slider?.destroy();
  }
}

if (!customElements.get('slider-bubble')) {
  customElements.define('slider-bubble', SliderBubble);
}
